// Mindestbestellmenge 3 für Stickservice
(function() {
  'use strict';

  function enforceMinQuantity() {
    if (!window.location.pathname.includes('einsticken-in-textil')) return;

    var qtyInput = document.querySelector('input[name="quantity"]');
    if (!qtyInput) return;

    qtyInput.setAttribute('min', '3');
    if (parseInt(qtyInput.value) < 3) {
      qtyInput.value = 3;
    }

    qtyInput.addEventListener('change', function() {
      if (parseInt(this.value) < 3) this.value = 3;
    });

    qtyInput.addEventListener('blur', function() {
      if (parseInt(this.value) < 3) this.value = 3;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceMinQuantity);
  } else {
    enforceMinQuantity();
  }
})();

/* ============================================
   FIX: Anmerkungen-Textarea in Product Form einbinden
   Fängt sowohl klassischen Submit als auch AJAX/Fetch ab
   ============================================ */
(function() {
  'use strict';

  var originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (url && typeof url === 'string' && url.includes('/cart/add') && options && options.body) {
      var textarea = document.querySelector('.dtf-notiz-wrap textarea');
      if (textarea && textarea.value.trim()) {
        try {
          if (options.body instanceof FormData) {
            options.body.set('properties[Anmerkungen]', textarea.value.trim());
          }
          else if (typeof options.body === 'string') {
            var data = JSON.parse(options.body);
            if (!data.properties) data.properties = {};
            data.properties['Anmerkungen'] = textarea.value.trim();
            options.body = JSON.stringify(data);
          }
        } catch(e) {
          console.warn('DTF Notiz-Fix: Konnte Anmerkung nicht einfuegen', e);
        }
      }
    }
    return originalFetch.apply(this, arguments);
  };

  document.addEventListener('DOMContentLoaded', function() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var textarea = document.querySelector('.dtf-notiz-wrap textarea');
    if (!form || !textarea) return;

    form.addEventListener('submit', function() {
      var existing = form.querySelector('input[name="properties[Anmerkungen]"]');
      if (existing) existing.remove();
      var value = textarea.value.trim();
      if (value) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'properties[Anmerkungen]';
        hidden.value = value;
        form.appendChild(hidden);
      }
    });
  });
})();

/* ============================================
   Modul: Upload-Hinweis Textilien
   Stand: Mai 2026
   ============================================ */
(function() {
  'use strict';

  function insertUploadHinweis() {
    if (document.querySelector('.textil-upload-hinweis')) return;

    var uploadkitBlock = document.querySelector('.uploadkit-uploader');
    if (!uploadkitBlock) return;

    /* Druckpositionen gibt es nur bei Textilien (P1 Abschluss 07.10.2026) */
    var isTextilProdukt = /\/products\/(t-shirt|hoodie|poloshirt|pullover|zip-hoodie)/.test(window.location.pathname);

    var hinweisHtml = '' +
      '<div class="textil-upload-hinweis" style="' +
        'margin: 16px 0;' +
        'padding: 16px;' +
        'border: 1px solid #e0c547;' +
        'border-radius: 8px;' +
        'background-color: #fef9e7;' +
        'font-size: 14px;' +
        'line-height: 1.6;' +
        'color: #333;' +
      '">' +
        '<p style="margin: 0 0 10px 0; font-weight: 700; font-size: 15px; color: #b8860b;">' +
          '\u26A0\uFE0F Wichtige Hinweise zur Druckdatei' +
        '</p>' +
        '<p style="margin: 0 0 8px 0;">' +
          '<strong>Transparenter Hintergrund:</strong> Bitte lade deine Datei als PNG mit transparentem Hintergrund hoch. ' +
          'Dateien ohne transparenten Hintergrund werden so gedruckt, wie sie hochgeladen wurden \u2013 inklusive Hintergrund.' +
        '</p>' +
        (isTextilProdukt ? '<p style="margin: 0;">' +
          '<strong>Druckpositionen & Preise:</strong> Die gew\u00FCnschte Druckposition (Brust, R\u00FCcken, \u00C4rmel) ' +
          'w\u00E4hlst du direkt hier auf der Produktseite aus. Der Aufpreis wird sofort angezeigt und automatisch in den Warenkorb \u00FCbernommen.' +
        '</p>' : '') +
      '</div>';

    var uploadContainer = uploadkitBlock.closest('.shopify-app-block') || uploadkitBlock.parentElement;
    if (uploadContainer) {
      uploadContainer.insertAdjacentHTML('afterend', hinweisHtml);
      return true;
    }
    return false;
  }

  // Versuche sofort
  if (!insertUploadHinweis()) {
    // Falls nicht gefunden, beobachte DOM-Änderungen
    var observer = new MutationObserver(function(mutations, obs) {
      if (insertUploadHinweis()) {
        obs.disconnect();
      }
    });
    observer.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
    // Sicherheits-Timeout: nach 10s aufhören zu beobachten
    setTimeout(function() { observer.disconnect(); }, 10000);
  }
})();